import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el material?',
  answer: <>
        <strong data-id="element-167">Inmediatamente después del pago</strong> recibirás un enlace de
        descarga. Es un PDF que podés leer en <em data-id="element-168">cualquier dispositivo</em>.
      </>
}, {
  question: '¿Sirve si mi pareja no quiere participar?',
  answer: <>
        <strong data-id="element-169">Sí.</strong> El material incluye una sección para aplicar{' '}
        <em data-id="element-170">cambios unilaterales</em> que generan un impacto positivo en el
        vínculo, incluso si el otro no hace nada.
      </>
}, {
  question: '¿Es un pago único?',
  answer: <>
        <strong data-id="element-171">Sí.</strong> Pagás una sola vez y tenés{' '}
        <em data-id="element-172">acceso de por vida</em> al material. Sin suscripciones ni costos
        ocultos.
      </>
}, {
  question: '¿Tiene garantía?',
  answer: <>
        <strong data-id="element-173">Sí.</strong> Si el contenido no te aporta valor, tenés{' '}
        <em data-id="element-174">7 días para pedir la devolución total</em>. Sin preguntas, sin
        vueltas.
      </>
}];
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038]" data-id="element-175">
      <div className="max-w-3xl mx-auto px-6" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-177">
          <div className="text-center mb-16" data-id="element-178">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center font-serif" data-id="element-179">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-4" data-id="element-180">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className="bg-[#1A0050] rounded-[20px] overflow-hidden border border-[#7C3AED]/30 shadow-sm" data-id="element-181">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#7C3AED]/10 transition-colors" data-id="element-182">
                  <span className="text-lg font-semibold text-white pr-4 font-sans" data-id="element-183">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-184">
                    <ChevronDownIcon className="w-5 h-5 text-[#7C3AED] flex-shrink-0" data-id="element-185" />
                  </motion.div>
                </button>
                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-186">
                  <div className="px-8 pb-6 text-[#C4B5FD] leading-relaxed font-sans" data-id="element-187">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}